<template>
  <div class="lmp-block clearBoth">

    <g-switch-list3
      :chip="chip"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :title="d.title"
      :columns="3"
      :list="d.list" />

    <g-switch-list2
      :chip="chip"
      class="lmp-vertical"
      v-for="(d, i) in data.vertical"
      :key="'v' + i"
      :vertical-type="1"
      :title="d.title"
      :list="d.list" />
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchList3 from '../../c_game-switch/switch-list/g_switch-3'; // 横向
  import GSwitchList2 from '../../c_game-switch/switch-list/g_switch-2'; // 纵向

  export default {
    name: "pk10_lmp",
    mixins: [mixin],
    components: {
      GSwitchList3,
      GSwitchList2
    }
  }
</script>

<style scoped lang="stylus">
  .lmp-vertical
    width calc(25% - 5.3px)
    float left
    margin-top 7px

  .lmp-vertical + .lmp-vertical
    margin-left 7px

  .lmp-vertical:nth-of-type(6)
    margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/gd_ha10/lmp.vue